import { createContext, useContext, useState } from "react";
import { AuthDialog } from "../components/landing/AuthDialog";

const AuthDialogContext = createContext(null);

export const AuthDialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [defaultTab, setDefaultTab] = useState("signup");

  const openAuth = (tab = "signup") => {
    setDefaultTab(tab);
    setOpen(true);
  };

  return (
    <AuthDialogContext.Provider value={{ openAuth }}>
      {children}
      <AuthDialog
        open={open}
        onOpenChange={setOpen}
        defaultTab={defaultTab}
        key={defaultTab + String(open)}
      />
    </AuthDialogContext.Provider>
  );
};

export const useAuthDialog = () => {
  const ctx = useContext(AuthDialogContext);
  if (!ctx) throw new Error("useAuthDialog must be used inside AuthDialogProvider");
  return ctx;
};
